import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { LEVELS, LEVEL_AR } from "@/masar/lib";
import { levelAccent } from "@/masar/colors";

export default function CurrentLevelPanel({ userId }) {
  const qc = useQueryClient();
  const [busy, setBusy] = useState("");
  const { data, error } = useQuery({ queryKey: ["masar-admin-user", userId], queryFn: async () => (await api.get(`/masar/admin/users/${userId}`)).data });
  const save = async (cid, level) => {
    setBusy(cid);
    try {
      await api.patch(`/masar/admin/users/${userId}/competencies/${cid}/current-level`, { level });
      await qc.invalidateQueries();
      toast.success("تم تحديث المستوى الحالي وبناء التدرج إلى الدرجة المطلوبة");
    } catch (e) { toast.error(e.response?.data?.detail || "تعذر تحديث المستوى"); }
    finally { setBusy(""); }
  };
  if (error) return <p className="text-xs text-ink-2">تعذر تحميل مستويات الموظف.</p>;
  if (!data?.assigned) return null;
  return <div className="space-y-3" data-testid="current-level-panel">
    <div><h3 className="font-bold">المستوى الحالي للموظف</h3><p className="text-xs text-ink-2">حدد نقطة بدء التعلّم لكل جدارة. الدرجة المطلوبة للوظيفة تبقى ثابتة.</p></div>
    <div className="grid sm:grid-cols-2 gap-2">{(data.requirements || []).filter(r => LEVELS.includes(r.target)).map(r => <label key={r.competency_id} style={levelAccent(r.target || r.level)} className="v2-inset p-3 block text-xs space-y-2">
      <span className="block font-bold">{r.name}</span><span className="block text-ink-2">المطلوب: {r.target} — {LEVEL_AR[r.target]}</span>
      <select aria-label={"المستوى الحالي: " + r.name} className="v2-input" value={r.current || ""} disabled={!!busy} onChange={e => save(r.competency_id, e.target.value)}>
        <option value="">الدرجة المطلوبة للوظيفة — لم يحدد المدير بداية أقل</option>{LEVELS.slice(0, LEVELS.indexOf(r.target) + 1).map(l => <option key={l} value={l}>{l} — {LEVEL_AR[l]}</option>)}
      </select>
    </label>)}</div>
  </div>;
}
